import { Box, Typography, Tooltip, Button, Dialog, DialogContent, DialogActions, DialogTitle, FormControl, TextareaAutosize, Select, InputLabel, MenuItem, TextField, Link } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import CommonListTable, { CommonListColumn } from "../Common/CommonListTable";
import {
  CookService,
  GetCookWalletResponse,
  GetCookWalletTransactionsResponse,
} from "../../services/CookServices";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import TransactionButton from "../Common/TransactionButton";
import { formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import VendorPayoutService from "../../services/VendorPayoutService";
import { getReasonCategory } from "../Common/constants/constant";
import ReasonSubreasonModuleEnum from "../../enums/ReasonSubreasonModuleEnum";
import { ActionTypeEnum } from "../../enums/ActionTypeEnum";

const cookServices = new CookService();
const vendorPayoutServices = new VendorPayoutService();

const RedeemDialog = (props: any) => {
  const handleCancel = () => {
    props.setOpen(false);
  };

  const handleSubmit = () => {
    props?.cookWalletRedeem();
    props?.setAmountRedeem(0);
    props.setOpen(false);
  };

  return (
    <div>
      <Dialog open={props.open}>
        <DialogTitle> {"Redeem Amount"} </DialogTitle>
        <DialogContent>
         <TextField id="outlined-basic" label="Please Enter Amount" variant="outlined" onChange={(e)=>props?.setAmountRedeem(e.target.value)}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>{"Cancel"}</Button>
          <Button onClick={handleSubmit}>{"Submit"}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const RevokePayout = (referenceId: { referenceId: number }) => {
  const RevokePayoutDialog = (props: { open: boolean, onClose: () => void }) => {
    const [revokeReason, setRevokeReason] = useState<string>("");
    const [reasons, setReasons] = useState<any>([]);
    const [other, setOther] = useState<string>("");

    const handleConfirm = () => {
      vendorPayoutServices.revokeVendorPayout(Number(referenceId?.referenceId), {
        comments: revokeReason === "Other" ? other : revokeReason,
      }).then((res) => {
        if (res) {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Revoke Payout Successful",
            type: CustomSnackbarTypes.SUCCESS,
          });
        }
      }).catch((err) => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: err?.response?.data?.error,
          type: CustomSnackbarTypes.ERROR,
        });
      }).finally(() => {
        props?.onClose();
      });
    };

    useEffect(() => {
      getReasonCategory(ReasonSubreasonModuleEnum.REVERSE_PAYOUT, ActionTypeEnum.PENALTY_REVOKE).then((data) => {
        setReasons(data);
      }).catch((err) => {
        console.log(err);
      });
    }, []);

    return (
      <Dialog open={props?.open} onClose={props?.onClose}>
        <DialogTitle>Please confirm the revoke of the payout.</DialogTitle>
        <DialogContent>
          <FormControl style={{ width: 500 }} fullWidth>
            <InputLabel id="demo-simple-select-label">Reason</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={revokeReason}
              label="Reason"
              onChange={(e) => setRevokeReason(e.target.value)}
            >
              {reasons && Array.isArray(reasons) && reasons.length > 0 && reasons.map((reasonObj: any) => (
                <MenuItem key={reasonObj?.category} value={reasonObj?.category}>{reasonObj?.category}</MenuItem>
              ))}
            </Select>
            {revokeReason === "Other" && (
              <TextareaAutosize
                value={other}
                minRows={5}
                onChange={(event) => { setOther(event.target.value); }}
              />
            )}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color={"error"} onClick={props?.onClose} size={"large"}>Cancel</Button>
          <Button variant="contained" color={"success"} onClick={handleConfirm} size={"large"}>Confirm</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const [openRevokePayoutDialog, setOpenRevokePayoutDialog] = useState<boolean>(false);
  return (
    <>
      <TransactionButton name={"Revoke Payout"} color="error" onClickHandler={() => setOpenRevokePayoutDialog(true)} />
      <RevokePayoutDialog open={openRevokePayoutDialog} onClose={() => setOpenRevokePayoutDialog(false)} />
    </>
  );
};

const TRANSACTION_COLUMNS: CommonListColumn[] = [
  { label: 'ID', field: 'id' },
  { label: 'Wallet ID', field: 'cookWalletId' },
  { label: 'Amount', field: 'amount' },
  {
    label: 'Notes',
    minWidth: 250,
    render: (row) => (
      <Tooltip title={row?.notes ?? ""}>
        <Typography variant="body1">{row?.notes ?? ""}</Typography>
      </Tooltip>
    ),
  },
  {
    label: 'Created At',
    nowrap: true,
    render: (row) => row?.createdAt ? formatDateTimeWithSeconds(row?.createdAt) : "---",
  },
  {
    label: 'Reference ID',
    render: (row) => {
      if (row?.referenceModelName === "VENDOR_PAYOUT") {
        return <Link href={`/#/VendorPayouts/${row?.referenceId}/show`}>{row?.referenceId}</Link>;
      } else if (row?.referenceModelName === "ONE_MEAL_SERVICE") {
        return <Link href={`/#/OneMealService/${row?.referenceId}/show`}>{row?.referenceId}</Link>;
      } else if (row?.referenceModelName === "TRIAL") {
        return <Link href={`/#/Trials/${row?.referenceId}/show`}>{row?.referenceId}</Link>;
      }
      return <div>{row?.referenceId}</div>;
    },
  },
  {
    label: 'Revoke Payout',
    stopRowClick: true,
    render: (row) => {
      if (row?.referenceId !== null && row?.referenceModelName === "VENDOR_PAYOUT" && row?.fromRevoked !== true) {
        return <RevokePayout referenceId={row?.referenceId} />;
      }
      return <div>REVOKE PAYOUT NOT AVAILABLE</div>;
    },
  },
  {
    label: 'Note English',
    minWidth: 300,
    render: (row) => <div>{row?.vendorPayoutEvent?.noteLocalEn}</div>,
  },
  {
    label: 'Note Hindi',
    minWidth: 300,
    render: (row) => <div>{row?.vendorPayoutEvent?.noteLocalHi}</div>,
  },
  {
    label: 'Note Bangla',
    minWidth: 300,
    render: (row) => <div>{row?.vendorPayoutEvent?.noteLocalBn}</div>,
  },
  {
    label: 'Vendor Payout Event Type',
    render: (row) => <div>{row?.vendorPayoutEvent?.type}</div>,
  },
  {
    label: 'Vendor Payout Event Product',
    render: (row) => <div>{row?.vendorPayoutEvent?.product}</div>,
  },
  {
    label: 'Vendor Payout Event',
    render: (row) => <div>{row?.vendorPayoutEvent?.event}</div>,
  },
  {
    label: 'Vendor Payout Event Tags',
    minWidth: 250,
    render: (row) => (
      <>
        {row && row?.vendorPayoutEvent && row?.vendorPayoutEvent?.tags?.length !== 0 &&
          row?.vendorPayoutEvent?.tags?.map((value: string, index: number) => (
            <Box display={'flex'} key={index}>
              <div>{value}</div>
              {index !== row?.vendorPayoutEvent?.tags?.length - 1 && <div>,&nbsp;</div>}
            </Box>
          ))}
      </>
    ),
  },
  {
    label: 'Vendor Payout Reason',
    minWidth: 350,
    render: (row) => <div>{row?.vendorPayoutEvent?.reason}</div>,
  },
];

const CookWalletTab = (props: { cookId: number }) => {
  const [cookWalletData, setCookWalletData] = useState<GetCookWalletResponse>();
  const [cookWalletTransactions, setCookWalletTransactions] = useState<GetCookWalletTransactionsResponse>();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [amountRedeem, setAmountRedeem] = useState(0);
  const [redeemOpen, setRedeemOpen] = useState(false);

  const cookWalletRedeem = async () => {
    try {
      if (amountRedeem > 0) {
        const response = await cookServices.redeemCookWalletBalance(props.cookId, amountRedeem.toString());
        if (response.status === 200) {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Redeem Successful",
            type: CustomSnackbarTypes.SUCCESS,
          });
          fetchCookWalletData();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCookTransactionData = useCallback(
    async (pageNo: number) => {
      const cooksWalletTransactionResponse = await cookServices.getCookWalletTransactions(
        props.cookId,
        pageSize,
        pageSize * pageNo,
        { order: "DESC", field: "createdAt" }
      );
      setCookWalletTransactions(cooksWalletTransactionResponse);
    },
    [props.cookId, pageSize]
  );

  const fetchCookWalletData = useCallback(async () => {
    const cooksWalletResponse = await cookServices.getCookWallet(props.cookId);
    setCookWalletData(cooksWalletResponse);
  }, [props.cookId]);

  useEffect(() => { fetchCookWalletData(); }, [fetchCookWalletData]);
  useEffect(() => { fetchCookTransactionData(0); }, [fetchCookTransactionData]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    fetchCookTransactionData(newPage);
  };

  const handleRowsPerPageChange = (rows: number) => {
    setPageSize(rows);
    setPage(0);
  };

  return (
    <Box>
      <RedeemDialog open={redeemOpen} setAmountRedeem={setAmountRedeem} cookWalletRedeem={cookWalletRedeem} setOpen={setRedeemOpen} />
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mb: "1rem" }}>
        Amount: {cookWalletData?.amount ?? "0"}
        <Button sx={{ ml: "2rem" }} onClick={() => setRedeemOpen(true)} variant="contained">
          Redeem
        </Button>
      </Box>
      <CommonListTable
        columns={TRANSACTION_COLUMNS}
        data={cookWalletTransactions?.data ?? []}
        loading={false}
        page={page}
        rowsPerPage={pageSize}
        total={cookWalletTransactions?.count ?? 0}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25, 50]}
        emptyText="No Data Found"
      />
    </Box>
  );
};

export default CookWalletTab;
